module.exports = __webpack_public_path__ + "static/img/icon-batchsetting.d3e9d7e4.svg";